import validate from "/portal-nuxt-app/node_modules/nuxt/dist/pages/runtime/validate.js";
import masuren_45translations_45global from "/portal-nuxt-app/middleware/masuren-translations.global.ts";
import manifest_45route_45rule from "/portal-nuxt-app/node_modules/nuxt/dist/app/middleware/manifest-route-rule.js";
export const globalMiddleware = [
  validate,
  masuren_45translations_45global,
  manifest_45route_45rule
]
export const namedMiddleware = {
  "guest-only": () => import("/portal-nuxt-app/middleware/guest-only.ts")
}